<div class="dmv-payment inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
        <div class="col-6 col-sm-2 mt-4 ">
          <a >
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>  
        </div>
  
        <div class="col-12 col-sm-8 mt-4">
          <div id="searchResu">Manual Renewal</div>
          <p id="addthereco">&nbsp; </p>
        </div>
  
  
        <div class="col-6 col-sm-2 icon-cart mt-4">
          <dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations" [registrationsManual]="dmvStoreService?.registrationsInCart?.dmvRegistrationsManual"  (clickEvent)="moveToRegistration($event)"></dmv-shoping-cart>
        </div>
  
        <!--heading section ends here-->
  

        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
      

        <form class="row mt-4 withForIe" autocomplete="off"  [formGroup]="manualRenewForm">
             <div class="asteriskMessage" >
         *Fields marked with an asterisk are required
        </div>
         <div class="col-12 col-sm-6">
            <div class="form-group">
                <div id="firstName">Vechicle Type*</div>
                      <div class="select-wrapper-2 monthpicker m-auto">                      
                          <select #vechicleTypeEle (click)="selectChange($event)" (keydown)="selectChangeByKey($event)"  (blur)="setDownIcon($event)" (change)="setDownIcon($event)" formControlName="vechicleType" class="form-control" required="required" [ngClass]="{ 'is-invalid': submitted && f.vechicleType.errors }" [value]="vechicleType" (change)="setVechicleType($event)" >
                                    <option value="" [selected]="vechicleType===''">Select One</option>
                                    <option [value]="item.registrationType" *ngFor="let item of dmvRegistrationTypes" [selected]="vechicleType===item.registrationType" >{{item.name}}</option>
                          </select>                           
                          <div class="invalid-feedback">Example invalid select vehicle type</div>
                      </div>
            </div>
        </div>  
            
            <div class="col-12 col-sm-6">
                <div class="form-group">
                    <div id="firstName">{{dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchLabel}}*</div>
                    <input type="text" (blur)="globalService.trimValue(f.tagNumber)" maxlength="15" class="form-control" formControlName="tagNumber" name="tagNumber" [ngClass]="{ 'is-invalid': submitted && f.tagNumber.errors }"> 
                    <div class="invalid-feedback" *ngIf="f.tagNumber.errors?.required">Please provide a valid {{dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchLabel}}.</div>
                    <div class="invalid-feedback" *ngIf="f.tagNumber.errors?.pattern">No symbols allowed except space and hyphen</div>
                </div>
            </div>            
 
            
            <div class="col-12 col-sm-6">
               <div class="form-group">
                   <label for="expirationDate" class="lblPin">REGISTRATION EXPIRATION (mm/dd/yyyy)*</label>
                    
                           <input [textMask]="{mask: mask}"  type="text" formControlName="expirationDate" class="form-control" placeholder="mm/dd/yyyy"
                                data-date-format="mm/dd/yyyy" id="expirationDate"
                                [ngClass]="{ 'is-invalid': submitted && f.expirationDate.errors }">
                            
                            <div *ngIf="submitted && f.expirationDate.errors" class="invalid-feedback">
                                <div *ngIf="f.expirationDate.errors.required">Please enter expiration date</div>
                                <div *ngIf="f?.expirationDate?.errors?.invalid">Invalid expiration date</div>
                                <div *ngIf="f.expirationDate.errors.pattern">Date must be in mm/dd/yyyy format</div>
                            </div>           
                    
                    
                </div>
            </div>
            
            <div class="col-12 col-sm-6" *ngIf="requiresInsurance">
                <div class="form-group">
                    <div id="firstName">Insurance Company(Max 40 Chars)*</div>
                    <input type="text" size="40" maxlength="40" class="form-control" name="inscomp" formControlName="insuranceCompany" [ngClass]="{ 'is-invalid': submitted && f.insuranceCompany.errors }">   
                     <div class="invalid-feedback"  *ngIf="f.insuranceCompany.errors?.required">Please enter name of
insurance company.</div>
                    <div class="invalid-feedback" *ngIf="f.insuranceCompany.errors?.pattern">Invalid symbols found.  Please retry.</div>
                </div>
            </div>
            <div class="col-12 col-sm-6" *ngIf="requiresInsurance">
                <div class="form-group">
                    <div id="firstName">Insurance Company Code (5 digits)*</div>
                    <input type="text" class="form-control"  name="insuranceIdNo" maxlength="5" formControlName="insuranceIdNo" [ngClass]="{ 'is-invalid': submitted && f.insuranceIdNo.errors }">             
                     <div class="invalid-feedback">Please enter a 5-digit
insurance company code.</div> 
                </div>
            </div>  
            
            <div class="col-12 col-sm-6" *ngIf="requiresInsurance">
                <div class="form-group">
                     <div id="firstName">Insurance Company Policy Number(Max 30 Chars)*</div>
                    <input type="text" size="30" maxlength="30" class="form-control" name="insurancePolicyNo" formControlName="insurancePolicyNo" [ngClass]="{ 'is-invalid': submitted && f.insurancePolicyNo.errors }">  
                    <div class="invalid-feedback" *ngIf="f.insurancePolicyNo.errors?.required">Please enter insurance policy number</div>
                    <div class="invalid-feedback" *ngIf="f.insurancePolicyNo.errors?.pattern">Invalid symbols found.  Please retry.</div>
                </div>
            </div>   


                <div  class="checkbox-container mt-3 mb-5" *ngIf="requiresInsurance"
                >
                    <label>Under penalty of perjury, I certify that I have Personal Injury Protection, Property Damage Liability, and, when required, Bodily Injury Liability coverage, for this vehicle. I understand that my driver’s license, license plate(s) and registration(s) will be suspended if this information is invalid. WARNING: Giving false information in order to obtain a vehicle registration certificate is a criminal offense and subject to prosecution.
                        <input type="checkbox" formControlName="certify" [ngClass]="{ 'is-invalid': submitted && f.certify.errors }">
                        <span class="checkmark border-checkmark" [ngStyle]="f.certify.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                        
                        [style.border-color]="(submitted && !f.certify.value)? '#dc3545':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"
                        ></span>                        
                     </label> 
                         <div *ngIf="submitted && !f.certify.value"  class="invalid-feedback insuranceAffidavitError" style="display:block">Please certify
the FL Insurance Affidvit by checking the checkbox.</div>
                </div> 
            
            <div class="col-6 col-sm-6">
                <div id="firstName">Amount to Pay*</div>
                 <div class="input-icon">   
                  <input type="number"   min="1" class="form-control" name="amountpay" formControlName="amount" placeholder="0.00" [ngClass]="{ 'is-invalid': submitted && f.amount.errors }">   
                    <div class="invalid-feedback" *ngIf="f.amount.errors?.required">Please provide amount to pay.</div>
                    <div class="invalid-feedback" *ngIf="f.amount.errors?.min">The minimum amount is $1.00</div>
                    <div class="invalid-feedback" *ngIf="f.amount.errors?.max">Amount must not be more than $5,000</div>
                    <div class="invalid-feedback" *ngIf="!f.amount.errors?.min && !f.amount.errors?.max && f.amount.errors?.pattern">Too many digits after the decimal point; 2 max</div>
                                 
                </div> 
            </div>
            
            <div class="col-6 col-sm-6">
                 <div id="firstName">Late Fee</div>
                   <div class="input-icon">   
                  <input min="0"  type="number"  class="form-control" name="latefee" formControlName="lateFee" placeholder="0.00" [ngClass]="{ 'is-invalid': submitted && f.lateFee.errors }">
                 
                  <div class="invalid-feedback" *ngIf="f.lateFee.errors?.required">Late Fee must be $0 or greater.</div>
                    <div class="invalid-feedback" *ngIf="f.lateFee.errors?.min">Late Fee must be $0 or greater.</div>
                    <div class="invalid-feedback" *ngIf="f.lateFee.errors?.max">Late Fee must not be more than $500</div>
                    <div class="invalid-feedback" *ngIf="!f.lateFee.errors?.min && !f.lateFee.errors?.max && f.lateFee.errors?.pattern">Too many digits after the decimal point; 2 max</div>
                                 
                </div>       
            </div>             
            
           
        </form>

        
      </div>
  
      <div class="m-auto text-center" >
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>                  
                <a >
                    <button class="btn btn-primary  btn-continue m-auto" (click)="continue()">Continue <i class="fa fa-chevron-right text-right"></i></button>
                </a>
            </div>  
  
  
    </div>
  </div>